import { AV } from './av';
import { Sfu } from './sfu';
import { Net } from '../../net/net';
import { LINK } from '../../../3-store/core/peers';
import { STUN } from '../../../../shared/protocol';

// 접속하면(welcome) 영상 연결(AV)과 서버 송출(Sfu)을 시작한다. /turn에서 TURN 목록을 한 번 받아 둔다(없으면 STUN만).
// 신호·SFU 요청은 서버로 보낸다. 서버는 같은 모임이 아닌 사람에게는 신호를 전하지 않는다(shared/world/links.ts)
let iceP: Promise<any[]> | null = null;
export function startAv(id: string) {
  iceP = iceP || fetch('/turn').then((r) => (r.ok ? r.json() : Promise.reject())).then((j) => (Array.isArray(j) ? j : j.iceServers)).catch(() => null).then((l) => (l && l.length ? l : STUN));
  iceP.then((ice) => {
    if (LINK.state !== 'online' || LINK.id !== id) return;
    AV.init({ myId: id, sendSig: (to: string, data: Record<string, unknown>) => Net.send({ t: 'sig', to, data }), iceServers: ice });
    Sfu.init({
      send: (q: number, op: any, body: unknown) => Net.send({ t: 'sfu', q, op, body }),
      iceServers: ice,
      onTrack: (who: string, kind: any, track: MediaStreamTrack | null) => AV.setExternal(who, kind, track),
      onDead: () => console.warn('[sfu] 서버 송출을 못 써서 직접 연결로만 이어집니다'),
    });
  });
}
